import React, {useState} from 'react';
import {StandardDatePicker} from './StandardDatePicker';
import {ContentWrapper} from './RangeDatePicker.style';
import {getEffectiveDate, isValidDate} from '../../utils';
import {generateIdentifier} from '../../utils/IdentityUtils';
import {TemplatePropertySettings} from '../../models/TemplatePropertySettings';
import {isMandatoryComponent, isVisibleComponent} from '../../utils/TemplateUtils';
import {
    STORAGE_OBJECT_OBJECT_METADATA,
    STORAGE_OBJECT_OBJECT_METADATA_DATE_VALID_FROM,
    STORAGE_OBJECT_OBJECT_METADATA_DATE_VALID_TO
} from '../../init/storage_object_constants';
import {t} from 'i18next';
import {Valid} from '../validation/Valid';

export interface RangeDatePickerProps {
    readonly templatePropertySettings: Map<string, TemplatePropertySettings>;
    readonly dateFrom?: Date;
    readonly labelFrom: string;
    readonly initializeFrom: boolean;
    readonly isClearableFrom: boolean;
    readonly isNullableFrom: boolean;
    readonly dateTo?: Date;
    readonly labelTo: string;
    readonly initializeTo: boolean;
    readonly isClearableTo: boolean;
    readonly  isNullableTo: boolean;
    onChange: (dateValidFrom?: Date, dateValidTo?: Date) => void;
}

export const RangeDatePicker: React.VFC<RangeDatePickerProps> = (props) => {
    const [dateValidFrom, setDateValidFrom] = useState<Date | undefined>(props.dateFrom);
    const [dateValidTo, setDateValidTo] = useState<Date | undefined>(props.dateTo);

    const onChangeDateFromHandler = (date?: Date) => {
        setDateValidFrom(date);
        props.onChange(date, dateValidTo);
    };

    const onChangeDateToHandler = (date?: Date) => {
        setDateValidTo(date);
        props.onChange(dateValidFrom, date);
    };

    return (
        <ContentWrapper id={generateIdentifier()}>
            {(isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA, props.templatePropertySettings)
                    && isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_DATE_VALID_FROM, props.templatePropertySettings)) &&
                <Valid
                    isValid={(isMandatoryComponent(STORAGE_OBJECT_OBJECT_METADATA_DATE_VALID_FROM, props.templatePropertySettings) ? isValidDate(dateValidFrom) : true)}
                    message={t('ERROR_DATE_VALID_FROM_MISSING')}>
                    <StandardDatePicker date={dateValidFrom}
                                        label={props.labelFrom}
                                        initialize={props.initializeFrom}
                                        isClearable={props.isClearableFrom}
                                        isNullable={props.isNullableFrom}
                                        minDate={getEffectiveDate()}
                                        maxDate={dateValidTo}
                                        onChange={onChangeDateFromHandler}/>
                </Valid>
            }
            {(isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA, props.templatePropertySettings)
                    && isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_DATE_VALID_TO, props.templatePropertySettings)) &&
                <Valid
                    isValid={(isMandatoryComponent(STORAGE_OBJECT_OBJECT_METADATA_DATE_VALID_TO, props.templatePropertySettings) ? isValidDate(dateValidTo) : true)}
                    message={t('ERROR_DATE_VALID_FROM_MISSING')}>
                    <StandardDatePicker date={dateValidTo}
                                        label={props.labelTo}
                                        initialize={props.initializeTo}
                                        isClearable={props.isClearableTo}
                                        isNullable={props.isNullableTo}
                                        minDate={dateValidFrom}
                                        maxDate={undefined}
                                        onChange={onChangeDateToHandler}/>
                </Valid>
            }
        </ContentWrapper>
    );
};
